;(function($, undefined){
    'use strict';

    var rnn = window.rnn;

  // Check for NCA ads (adcore, but it doesn't always exist in time..), if they exist don't continue.
  if( $('body.adcore').length || $('.ad-block').length > 0){ return false }

    function initdynamicAdSpaces(){
        var isSubscriberUser = typeof(isSubscriber) === 'function' && isSubscriber();
        var $articleBody = $(".newsEntry .story-body:not(.glance-description)");
        var $articleParas = $articleBody.children("p");
        var $topicArticles = $(".topic .headline-list > .item");
        var $mrecPos = $topicArticles.length < 4 ? $topicArticles.length - 1 : 3;
        var $adGroup = $('<div class="adGroup adGroupLabel"><div id="mobileAd1" class="adSpace"></div></div>');
        var $noMobileSearchResults = $('.js-no-search-results');
        var $mobileSearchResults = $('.headline-image-tease');
        var $mobileSearch = $('.mobile-search');

        if ($articleParas.length > 9) {
            if (!isSubscriberUser) {
                $adGroup.insertAfter($articleParas.eq(4));
            } else {
                $adGroup.insertAfter($articleParas.eq(6));
            }
        } else {
            $articleBody.append($adGroup);
        }

        if ($topicArticles.length) {
            $adGroup.insertAfter($topicArticles.eq($mrecPos));
        }

        // insert before editors picks page banner
        if(window.location.pathname === '/'){
            $('.pageSegment').each(function() {
                var $this = $(this);
                if ($this.data().overlayMarker !== undefined &&
                    $this.data().overlayMarker.label === 'Editors Picks: Editors Picks') {
                    $('<div class="adGroup"><div id="mobileAd4" class="adSpace"></div></div>').insertBefore($this);
                }
            });
        }

        // Mobile Search Results Page
        // - for all users we need to show the mobileAd1 in position 6
        // - if less than 5 results just show last
        if ($mobileSearch.length) {
            if ($mobileSearchResults.length > 4) {
                $adGroup.insertAfter($mobileSearchResults.eq(4));
            } else {
                $adGroup.insertAfter($mobileSearchResults.eq($mobileSearchResults.length - 1));
            }
        }
        // - for no results
        if ($noMobileSearchResults.length) {
            $adGroup.insertAfter($noMobileSearchResults);
        }
    }

    rnn.modules.register('dynamicAdSpaces', {
        init: initdynamicAdSpaces,
    });

})(jQuery);
